"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIndexes = exports.Colors = void 0;
var Colors = /** @class */ (function () {
    function Colors(values) {
        var grays = values.grays, black = values.black, white = values.white, primary = values.primary, secondary = values.secondary;
        this.grays = grays;
        this.black = black;
        this.white = white;
        this.primary = primary;
        this.secondary = secondary;
    }
    Object.defineProperty(Colors.prototype, "bg", {
        get: function () {
            return this.grays[2];
        },
        enumerable: false,
        configurable: true
    });
    return Colors;
}());
exports.Colors = Colors;
var colors = new Colors({
    grays: ['#e6e6e6', '#d2d2d2', '#c3c7cb', '#868a8e'],
    black: '#000000',
    white: '#ffffff',
    primary: '#000e7a',
    secondary: '#55aaaa',
});
var space = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
];
var borderWidths = [0, 1];
var borderStyles = ['none', 'solid'];
var shadows = {
    out: "inset 0.5px 0.5px 0px 0.5px " + colors.white + ",\n        inset 0 0 0 1px " + colors.grays[3] + ",\n        1px 0px 0 0px " + colors.black + ",\n        0px 1px 0 0px " + colors.black + ",\n        1px 1px 0 0px " + colors.black,
    in: "inset 0px 0px 0px 0px,\n      inset 1px 1px 0px 0px " + colors.grays[3] + ",\n      0.5px 0.5px 0px 0.5px " + colors.white,
    input: "inset -1px -1px 0 0 " + colors.grays[2] + ",\n          inset 1px 1px 0 0 " + colors.black + ",\n          0.5px 0.5px 0 0.5px " + colors.white,
};
var ZIndexes = /** @class */ (function (_super) {
    __extends(ZIndexes, _super);
    function ZIndexes(values) {
        return _super.apply(this, values) || this;
    }
    Object.defineProperty(ZIndexes.prototype, "modal", {
        get: function () {
            var _a;
            return (_a = this._modal) !== null && _a !== void 0 ? _a : this[1];
        },
        set: function (value) {
            this._modal = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZIndexes.prototype, "taskbar", {
        get: function () {
            var _a;
            return (_a = this._taskbar) !== null && _a !== void 0 ? _a : this[2];
        },
        set: function (value) {
            this._taskbar = value;
        },
        enumerable: false,
        configurable: true
    });
    return ZIndexes;
}(Array));
exports.ZIndexes = ZIndexes;
var zIndices = new ZIndexes([0, 1, 2]);
zIndices.modal = zIndices[1], zIndices.taskbar = zIndices[2];
var theme = {
    colors: colors,
    space: space,
    shadows: shadows,
    borderWidths: borderWidths,
    borderStyles: borderStyles,
    zIndices: zIndices,
};
exports.default = theme;
//# sourceMappingURL=theme.js.map